// extracted by mini-css-extract-plugin
export default {"info-container":"info_info-container__U9Bl2","link-text":"info_link-text__Mz498"};